/**
 * Thin, exception-safe wrapper around localStorage. Returns null /
 * silently no-ops when storage is unavailable (SSR, private mode,
 * cookies-blocked browsers, quota exceeded).
 */
const STORAGE_KEY = 'twg-microsite.locale';

const getStorage = (): Storage | null => {
	try {
		// `globalThis.localStorage` may throw on access in some sandboxed iframes.
		// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
		return typeof globalThis !== 'undefined' && globalThis.localStorage
			? // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
				globalThis.localStorage
			: null;
	} catch {
		return null;
	}
};

export const readPersistedLocale = (): string | null => {
	const storage = getStorage();
	if (!storage) {
		return null;
	}
	try {
		return storage.getItem(STORAGE_KEY);
	} catch {
		return null;
	}
};

export const writePersistedLocale = (locale: string): void => {
	const storage = getStorage();
	if (!storage) {
		return;
	}
	try {
		storage.setItem(STORAGE_KEY, locale);
	} catch {
		// Quota exceeded or storage disabled mid-session — non-fatal.
	}
};
